import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Image, Row } from 'react-bootstrap';
import { ErrorToast, SuccessToast, WarningToast } from '../../../utils/toasters';
import { CampaignsService } from '../CampaignsService';
import { useNavigate, useParams } from 'react-router-dom';
import { multipartFormData } from '../../../api/api.service';
import { CAMPAIGN_TYPES_URL } from '../../../utils/Endpoints';
import { ICampaignType } from '../../../model/campaign/ICampaignType';

export function CampaignTypeForm() {
    const [type, setType] = useState<ICampaignType>({
        title: '',
        description: '',
        descriptionGerman: '',
        followersRangeFrom: 0,
        followersRangeTo: 0,
        isActive: false,
    });
    const { typeId } = useParams();
    const [selectedFile, setSelectedFile] = useState(null);
    const [imagePath, setImage] = useState('');
    const [check, setCheck] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (typeId) {
            CampaignsService.getCampaignType(+typeId)
                .then(response => {
                    setType(response);
                    if (response?.creatorTypeImage) {
                        setImage(response?.creatorTypeImage?.path);
                    }
                    setCheck(response.isActive);
                })
                .catch(err => ErrorToast(err));
        }
    }, []);

    useEffect(() => {
        setType({ ...type, isActive: check });
    }, [check]);

    const createCampaignType = (e: any) => {
        e.preventDefault();
        if (
            type.title !== '' &&
            type.description !== '' &&
            type.followersRangeFrom !== 0 &&
            type.followersRangeTo !== 0
        ) {
            multipartFormData(selectedFile, CAMPAIGN_TYPES_URL, JSON.stringify(type), 'post')
                .then(() => {
                    SuccessToast('Successfully created campaign type');
                    navigate('/campaign/types');
                })
                .catch(error => ErrorToast(error));
        } else {
            WarningToast('Please fill out all mandatory fields');
        }
    };

    const updateCampaignType = (e: any) => {
        e.preventDefault();
        multipartFormData(selectedFile, `${CAMPAIGN_TYPES_URL}/${typeId}`, JSON.stringify(type))
            .then(() => {
                SuccessToast('Successfully updated campaign type');
                navigate('/campaign/types');
            })
            .catch(error => ErrorToast(error));
    };

    function handleChange(event: any) {
        const value = event.target.value;
        setType({
            ...type,
            [event.target.name]: value,
        });
    }

    function handleFileInput(evt: any) {
        if (evt.target.files.length > 0) {
            setSelectedFile(evt.target.files[0]);
            setImage(URL.createObjectURL(evt.target.files[0]));
        }
    }

    return (
        <Card>
            <Form as={Card.Body}>
                <h3> {typeId ? 'Update type' : 'Create type'}</h3>
                <hr />
                <Row>
                    <Col md={8}>
                        <Form.Group>
                            <Form.Label className="required">Title</Form.Label>
                            <Form.Control
                                id="campaignTypeInput"
                                name="title"
                                onChange={handleChange}
                                defaultValue={type.title}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label className="required">Description English</Form.Label>
                            <Form.Control
                                id="campaignTypeInput"
                                as="textarea"
                                maxLength={255}
                                name="description"
                                onChange={handleChange}
                                defaultValue={type.description}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label className="required">Description German</Form.Label>
                            <Form.Control
                                id="campaignTypeInput"
                                as="textarea"
                                maxLength={255}
                                name="descriptionGerman"
                                onChange={handleChange}
                                defaultValue={type.descriptionGerman}
                            />
                        </Form.Group>
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="required">Followers range from</Form.Label>
                                    <Form.Control
                                        id="campaignTypeInput"
                                        type="number"
                                        name="followersRangeFrom"
                                        onChange={handleChange}
                                        value={type.followersRangeFrom}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="required">Followers range to</Form.Label>
                                    <Form.Control
                                        id="campaignTypeInput"
                                        type="number"
                                        name="followersRangeTo"
                                        onChange={handleChange}
                                        value={type.followersRangeTo}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group>
                            <Form.Check
                                label="active"
                                name="active"
                                onChange={() => setCheck(!check)}
                                checked={check}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        <Form.Group>
                            <Form.Label>Upload photo</Form.Label>
                            <Form.Control accept=".jpg, .jpeg, .png" type="file" onChange={handleFileInput} />
                            {imagePath && (
                                <Image
                                    className="mt-3 img-cover"
                                    width={300}
                                    height={250}
                                    alt={imagePath}
                                    src={imagePath}
                                />
                            )}
                        </Form.Group>
                    </Col>
                </Row>
                <Button
                    onClick={typeId ? updateCampaignType : createCampaignType}
                    className="mt-4"
                    size="lg"
                    type="submit"
                >
                    Save
                </Button>
            </Form>
        </Card>
    );
}
